import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { REGEX } from '../../../core/constants/regex.const';
import { nameValidator } from '../../../core/helpers/validators.helper';

@Component({
  selector: 'xplora-website-member-step2',
  standalone: true,
  imports: [
    MatDialogModule,
    TranslateModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    CommonModule
  ],
  templateUrl: './member-step2.component.html',
  styleUrl: './member-step2.component.scss'
})
export class MemberStep2Component {
  submitted: boolean = false;
  memberFormGroup: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private MatDialogRef: MatDialogRef<MemberStep2Component>
  ) {
    this.memberFormGroup = this.formBuilder.group({
      bankName: ['', [nameValidator(), Validators.pattern(REGEX.STRING_ONLY)]],
      accountHolderName: ['', Validators.required],
      branchName: ['', Validators.required],
      bankCode: ['', Validators.required]
    });
  }

  close(): void {
    this.MatDialogRef.close(false);
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.memberFormGroup.valid) {
      this.MatDialogRef.close(this.memberFormGroup.value);
    }
  }
}
